module.exports = __webpack_public_path__ + "img/2.cd4df05e.png";